<template>
    <VForm
        v-slot="{ errors }"
        @submit="onSubmit">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <BaseInput
                v-model="model.firstname"
                :label="$t('auth.firstname')"
                rules="required|max:255"
                required
                autocomplete="given-name"
                name="register-firstname" />
            <BaseInput
                v-model="model.lastname"
                :label="$t('auth.lastname')"
                rules="required|max:255"
                required
                autocomplete="family-name"
                name="register-lastname" />
            <BaseInput
                v-model="model.email"
                :label="$t('auth.email')"
                class="md:col-span-2"
                rules="required|email|max:255"
                required
                autocomplete="username"
                type="email"
                name="register-email" />
            <div>
                <BaseInput
                    v-model="model.password"
                    :label="$t('auth.password')"
                    type="password"
                    name="register-password"
                    rules="required|verify_password"
                    autocomplete="new-password"
                    required />
                <PasswordStrengthMeter
                    :model-value="model.password"
                    :strength-meter-only="true" />
            </div>

            <BaseInput
                v-model="model.password_confirmation"
                :label="$t('auth.repeatPassword')"
                :rules="{required: true, confirm_password: model.password}"
                required
                type="password"
                autocomplete="new-password"
                name="reset-password-confirmation" />

            <div class="md:col-span-2">
                <h3>{{ $t('auth.organisation') }}</h3>
                <div class="font-light text-sm">
                    {{ $t('auth.organisationHelpText') }}
                </div>
                <AuthCodeInput
                    v-model="model.authCode"
                    class="mt-4" />
            </div>

            <BaseButton
                class="w-full md:col-span-2"
                color="primary"
                :disabled="loading || !!Object.keys(errors).length"
                type="submit">
                <span v-if="!loading">{{ $t('auth.register') }}</span>
                <span v-else>
                    <LoadingSpinner />
                    {{ $t('auth.pleaseWait') }}
                </span>
            </BaseButton>

            <div class="flex justify-end md:col-span-2">
                <span
                    class="font-bold text-decoration-none cursor-pointer"
                    @click.prevent="emits('authPageVisible', 'AuthLogin')">{{ $t('auth.back') }}</span>
            </div>
        </div>
    </VForm>
</template>

<script setup>
import {useAuthStore} from '@/store/auth'

const authStore = useAuthStore()
const notification = useNotification()
const {$apiRoute} = useNuxtApp()

const model = ref({
    firstname: null,
    lastname: null,
    email: null,
    password: null,
    password_confirmation: null,
    remember: true,
    authCode: null,
})

const emits = defineEmits(['authPageVisible'])

const loading = ref(false)

async function onSubmit(values, actions) {
    loading.value = true

    await $lara.post($apiRoute('spa.auth.register'), {
        body: {...model.value}
    }).then(async response => {
        loading.value = false
        await login()
        notification.success(t('users.welcome', {name: model.value.firstname}))
    }).catch(async error => {
        loading.value = false
        notification.error(error.response._data?.message)
        // actions.setErrors(error.response._data?.errors);
    })
}


async function login() {
    loading.value = true

    await $lara.post($apiRoute('spa.login.authenticate'), {
        body: {...model.value}
    }).then(async response => {
        await authStore.successfulLogin('/', {celebrate: 1})
        loading.value = false
    }).catch(async error => {
        loading.value = false

        notification.error(error.response._data?.message)
    })
}

</script>